module.exports = __webpack_public_path__ + "img/cards1_front151.9524f5db.png";